<div>
    <button mat-button type="button" color="primary" (click)="addTransition()" i18n>Add workflow transition</button>

    <div *ngFor="let transition of transitions; let i = index">
      <mat-card appearance="outlined">
        <div>
          <strong>{{ transition.name }}</strong>
          <button mat-button type="button" color="primary" (click)="editTransition(i)" i18n>Edit</button>
          <button mat-button type="button" color="warn" (click)="removeTransition(i)" i18n>Remove</button>
        </div>
        <div>
          <ub-label label="Destination state" text="{{ getStateTitle(transition.destination) }}" i18n-label></ub-label>
          <ub-label *ngIf="transition.actions" label="Actions" [text]="transition.actions | pick:'action'" i18n-label></ub-label>
          <ub-label *ngIf="transition.guards" label="Guards" [text]="transition.guards | pick:'guard'" i18n-label></ub-label>
        </div>
      </mat-card>
    </div>
  </div>
